import { push, goBack } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import globals from '../../../globals/communityGlobals';

export const eventHandlers = (state, setState) => {
  const dispatch = useDispatch();

  return {
    locale: globals.getArea('patients'),
    refreshTable: () => setState({ ...state, forceReload: !state.forceReload, mileageCapList: {} }),
    updateTableProps: (currentPage, pageSize) => setState({ ...state, currentPage, pageSize }),
    updateTableSort: (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection }),
    goBack: () => dispatch(goBack()),
    go: url => dispatch(push(url)),
    handleSidePanel: (selectedEntry, isPatientAudit) => {
      setState(newState => ({
        ...newState,
        unsuccessfullyPatientRequest: isPatientAudit ? null : selectedEntry,
        patientAuditHistory: isPatientAudit ? selectedEntry : null,
      }));
    },
    onCloseDetailPanel: () =>
      setState({
        ...state,
        unsuccessfullyPatientRequest: null,
        patientAuditHistory: null,
      }),
    onFiltersChange: model =>
      setState({
        ...state,
        from: model.from,
        to: model.to,
        forename: model.forename,
        surname: model.surname,
        nhsNumber: model.nhsNumber.replace(/ /g, ''),
        dateOfChange: model.dateOfChange,
        auditType: model.auditType,
        sortColumn: model.auditType === 1 ? 'DateCreated' : model.sortColumn,
        currentPage: 1,
      }),
  };
};
